import * as React from "react"

const SvgComponent = (props) => (
        <svg width="1em" height="1em" viewBox="0 0 55 55" {...props}>
            <path
                d="M34.641 18.315l-2.588.002c-2.03 0-2.423.964-2.423 2.378v3.122h4.841l-.63 4.89H29.63V41.25h-5.048V28.707H20.36v-4.89h4.222v-3.604c0-4.186 2.555-6.463 6.287-6.463 1.787 0 3.324.132 3.772.192v4.373zM27.5 0C12.313 0 0 12.311 0 27.5 0 42.687 12.313 55 27.5 55 42.689 55 55 42.687 55 27.5 55 12.311 42.689 0 27.5 0z"
                fill="#FFF"
                fillRule="evenodd"
            />
        </svg>
    );

export default SvgComponent

